@if(form){
<form class="my-form" [formGroup]="form">
	@if(allUsers && contactPersonsFormArray().controls.length > 0) {
	<div formArrayName="contactPersons" class="wrapper">
		@for(person of contactPersonsFormArray().controls; track person; let i = $index) {
		<div class="contacts-container flex flex-row flex-align-stretch-center">
			<div [formGroupName]="i" class="contact-person flex flex-row flex-align-center-space-between">
				<input-wrapper class="select custom-wrapper" label="Contact person">
					<input-autocomplete
						formControlName="name"
						[label]="'Contact person'"
						[disabled]="!this.canEditContactPersons"
						[options]="users$ | async"
					>
					</input-autocomplete>
					@if((person.get('name')?.dirty || person.get('name')?.touched) &&
					person.get('name')?.errors?.required) {
					<div input-errors>Contact person name is required</div>
					}
				</input-wrapper>

				<input-wrapper class="select" class="custom-wrapper" label="Contact position">
					<input
						[disabled]="true"
						formControlName="positions"
						readonly
						[placeholder]="'Contact position'"
						[matTooltip]="person.get('positions')?.value"
					/>
				</input-wrapper>

				<input-wrapper class="custom-wrapper" label="Contact email">
					<input type="text" placeholder="Contact person email" formControlName="email" />
				</input-wrapper>

				<input-wrapper class="custom-wrapper" label="Contact phone">
					<input type="number" placeholder="Contact phone" formControlName="phone" />
				</input-wrapper>

				@if(canEditContactPersons) {
				<div (click)="removeContactPerson(i)" class="delete-icon" aria-hidden="true">
					<app-icon
						id="trash-contact"
						[name]="'trash'"
						[color]="'var(--inactive-text-red)'"
						[size]="'28'"
					></app-icon>
				</div>
				}
			</div>
		</div>
		}
	</div>
	}
</form>
} @if(!allUsers) {
<div class="pulsate">Fetching users...</div>
}
